<template>
  <v-menu
    transition="slide-y-transition"
    close-on-click
  >
    <template #activator="{ props }">
      <v-btn v-bind="props">
        <v-icon class="mr-1">
          mdi-web
        </v-icon>
        <span>{{ caption }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :class="{ 'v-list-item--active': selected === index }"
        :value="index"
        @click="changeLanguage(index)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';

import {getLocale, setLocale} from '@/Foundation/helpers/storage.ts';

const {locale} = useI18n();

const items = [
  {locale: 'en', title: 'English'},
  {locale: 'de', title: 'German'},
  {locale: 'fr', title: 'French'},
];

const selected = ref(0);

const caption = computed(() => items[selected.value].title);

function changeLanguage(index) {
  selected.value = index;
  locale.value = items[index].locale;
  setLocale(locale.value);
}

onMounted(() => {
  const savedLocale = getLocale();
  if (savedLocale) {
    const idx = items.findIndex(item => item.locale === savedLocale);
    if (idx !== -1) selected.value = idx;
  }
});
</script>

<script lang="ts">
export default {
  name: 'LanguageSwitcher',
};
</script>
